import { render, staticRenderFns } from "./page-container.vue?vue&type=template&id=63669eac&scoped=true&"
var script = {}
import style0 from "./page-container.vue?vue&type=style&index=0&id=63669eac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63669eac",
  null
  
)

export default component.exports